import {
  BottomSheetBody,
  BottomSheetFooter,
  BottomSheetHeader,
  BottomSheetHeaderTitle,
  Flex,
  FlexColumn,
  ItemAvatar,
  ItemContent,
  ItemSide,
  Separator,
  Skeleton,
  SkeletonBlock,
} from "@opensea/ui-kit"
import { useTranslations } from "use-intl"
import { Item } from "../../../components/Item"

export function CancelOrderFlowSkeleton({ count = 1 }: { count?: number }) {
  const t = useTranslations("wallet.CancelOrderFlow")
  return (
    <>
      <BottomSheetHeader>
        <BottomSheetHeaderTitle>{t("cancelOrder")}</BottomSheetHeaderTitle>
      </BottomSheetHeader>
      <BottomSheetBody className="pb-0">
        <FlexColumn>
          {new Array(count).fill(0).map((_, index) => (
            <Item className="py-2.5" key={index} variant="unstyled">
              <ItemAvatar size={48}>
                <SkeletonBlock className="size-12 rounded" />
              </ItemAvatar>
              <ItemContent className="gap-2">
                <Skeleton className="w-24" />
                <Skeleton className="w-32" />
              </ItemContent>
              <ItemSide>
                <Skeleton className="w-16" />
                <Skeleton className="w-12" />
              </ItemSide>
            </Item>
          ))}
        </FlexColumn>
        <Separator />
      </BottomSheetBody>
      <BottomSheetFooter>
        <Flex className="justify-end">
          <SkeletonBlock className="h-10 w-[120px] rounded" />
        </Flex>
      </BottomSheetFooter>
    </>
  )
}
